import { useNavigate, useLocation } from "react-router-dom";
import { Settings } from "lucide-react";
import { useAuth } from "../auth/AuthProvider";

export default function AppHeader() {
  const { user, loading, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinkBase =
    "text-sm font-medium inline-flex items-center justify-center transition-colors";
  const activeClasses = "text-[#043C5A]";
  const inactiveClasses = "text-zinc-600 hover:text-zinc-900";

  return (
    <header className="w-full bg-white shadow-sm">
      <div className="max-w-4xl mx-auto px-3 sm:px-4 py-2 sm:py-3 flex items-center justify-between gap-3">
        {/* Left: logo + DobieCore text */}
        <button
          type="button"
          onClick={() => navigate("/")}
          className="group flex items-center sm:flex-col gap-2"
        >
          <img
            src="/dobiecore-suite-hero.png"
            alt="DobieCore Suite"
            className="block w-10 h-10 sm:w-16 sm:h-16 object-contain border-2 border-[#042d4d] rounded-lg shadow-lg shadow-gray-200 group-hover:shadow-gray-300 transition-shadow"
          />
          <span className="text-lg sm:text-xl font-semibold text-[#043C5A] tracking-tight group-hover:opacity-80">
            DobieCore
          </span>
        </button>

        {/* Right: nav (desktop) */}
        <nav className="hidden sm:flex items-center gap-4">
          <button
            type="button"
            onClick={() => navigate("/")}
            className={`${navLinkBase} ${
              isActive("/") ? activeClasses : inactiveClasses
            }`}
          >
            Home
          </button>

          <button
            type="button"
            onClick={() => navigate("/prewriting")}
            className={`${navLinkBase} ${
              isActive("/prewriting") ? activeClasses : inactiveClasses
            }`}
          >
            Prewriting
          </button>

          <button
            type="button"
            onClick={() => navigate("/captions")}
            className={`${navLinkBase} ${
              isActive("/captions") ? activeClasses : inactiveClasses
            }`}
          >
            Captions
          </button>

          <button
            type="button"
            onClick={() => navigate("/blog")}
            className={`${navLinkBase} ${isActive("/blog") ? activeClasses : inactiveClasses}`}
          >
            Blog
          </button>


          <button
            type="button"
            onClick={() => navigate("/images")}
            className={`${navLinkBase} ${
              isActive("/images") ? activeClasses : inactiveClasses
            }`}
          >
            Images
          </button>

          <button
            type="button"
            onClick={() => navigate("/settings")}
            className={`${navLinkBase} gap-1 ${
              isActive("/settings") ? activeClasses : inactiveClasses
            }`}
          >
            <Settings size={16} />
            Settings
          </button>
        </nav>

      </div>
      <div className="text-sm text-gray-600">
        {loading ? (
          <span>Checking sign-in...</span>
        ) : user ? (
          <div className="flex items-center gap-2">
            <span>Welcome, {user.email}</span>
            <button
              onClick={signOut}
              className="underline text-gray-500 hover:text-gray-700"
            >
              Sign out
            </button>
          </div>
        ) : (
          <span>Not signed in</span>
        )}
      </div>
    </header>
  );
}
